module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1010-ab3d0fdcea9e5a57ee4f9cae6b993266.png";